import React from 'react'
import { Search } from '../search/search'
import './filter.css'

function Filter(props) {
    const [arrToCheckbox, setArrToCheckbox] = React.useState([])
    const arrFilter = props.arr.filter(el => arrToCheckbox.includes(el[props.objKey][props.valueKey]))

    const handleCheckboxChange = (event) => {
        const { value, checked } = event.target;
        if (checked) {
            setArrToCheckbox((prevCheckboxes) => [...prevCheckboxes, value]);
        } else {
            setArrToCheckbox((prevCheckboxes) =>
                prevCheckboxes.filter((checkbox) => checkbox !== value)
            );
        }
    }

    var novaArr = props.arr.filter(function (este, i, arr) {
        return arr.findIndex(function (obj) {
            return este[props.objKey][props.valueKey] === obj[props.objKey][props.valueKey]
        }) === i;
    });


    React.useEffect(() => {
        if (arrToCheckbox.length > 0) {
            props.function(arrFilter)
        } else {
            props.function(props.arr)
        }
    }, [arrToCheckbox])

    return (
        <section style={props.show ? { display: 'flex', ...props.props } : { display: 'none', ...props.props }} className='filter-content-component-v2'>
            <div className='title-filter-component' style={{ display: 'flex' }}>
                <h1>Filter by {props.objKey}</h1>
                <h3>*</h3>
            </div>
            <div className='infos-filter-component'>
                {
                    novaArr.map((value, i) => {
                        return (
                            <div className='row-site-filter'>
                                <input id={`idInput${i}`} value={value[props.objKey][props.valueKey]} onChange={handleCheckboxChange} type='checkbox' />
                                <h2>{Array.isArray(value[props.objKey][props.valueKey]) ? value[props.objKey][props.valueKey].length > 0 ? value[props.objKey][props.valueKey][0] : '' : value[props.objKey][props.valueKey]}</h2>
                            </div>
                        )
                    })
                }
            </div>
        </section>
    )
}

export default Filter